export interface IUserInfoResponse {
    userDetails: {
        name: string
        email: string
        role: string
        id: string
    }
    lastSessionDetails: {
        badgeNumber: string
        busHubCode: string
        dutyCode: string
        startedAt: string
        authorName: string
        isNightShift: boolean
    }
}

export interface IEmployee {
    badgeNumber: string
    iBusHubCode: string
    firstName: string
    lastName: string
    id: string
}

export enum Employee {
    Driver = 'Driver',
    Controller = 'Controller',
}
export interface IUserShift {
    id: string
    badgeNumber: string
    busHubCode: string
    authorName: string
    dutyCode: string
    workstation: string
    createdAt: string
    dutyFrom: string
    dutyTo: string
    oid: string
    previousDutyCode: string | null
}
